@if (person$ | async; as person) {
    <div class="px-0 px-md-3 h-100">
        <div adaptToolbarContent
             alignment="right">
            @if (!showTourPrompt) {
                <button data-tour="personal-dashboard-tour"
                        adaptButton="tour"
                        (click)="runTour()"></button>
            }
        </div>
        <div adaptToolbarContent
             [ordinal]="1000">
            <a [routerLink]="personalConfigLink$ | async"
               adaptButton="configureLink"
               adaptTooltip="Go to personal configuration"></a>
        </div>
        <adapt-activity-page-content class="h-100">
            <ng-container activity-pathway-page-before>
                <!-- Just a way to check for email confirmed  -->
                @if (!emailConfirmed) {
                    <div class="my-4 alert alert-info alert-dismissible d-none"
                         role="alert"
                         left-column>
                        <!-- bs alert dismissible not working anymore?? tried both bs-dismiss and dismiss - both not working
            ended up just using a (click) instead -->
                        <span type="button"
                              (click)="emailConfirmed = true"
                              class="btn-close"
                              data-bs-dismiss="alert"
                              aria-label="Close"></span>
                        Please confirm your account - a confirmation email has been sent
                    </div>
                }
                @if (showTourPrompt || showCoachSessionPrompt) {
                    <div class="mb-4 cta-container">
                        @if (showTourPrompt) {
                            <div class="mb-3">
                                <adapt-alto-shell-tour-prompt-dashboard-element
                                                                                [person]="person"></adapt-alto-shell-tour-prompt-dashboard-element>
                            </div>
                        }
                        @if (showCoachSessionPrompt) {
                            <adapt-alto-coach-prompt-dashboard-element></adapt-alto-coach-prompt-dashboard-element>
                        }
                    </div>
                }
            </ng-container>
            <div activity-pathway-page-after
                 class="mt-4">
                <adapt-display-ongoing-survey-personal-dashboard-element
                                                                         [person]="person"></adapt-display-ongoing-survey-personal-dashboard-element>
            </div>
        </adapt-activity-page-content>
    </div>
}
